import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserOrganizeDeskGame from 'src/games/OrganizeDeskGame/Main';

interface OrganizeDeskGame extends PageProps<{}> {
    onComplete?: () => void;

}

class OrganizeDeskGame extends React.Component<OrganizeDeskGame> {
    constructor(props: OrganizeDeskGame) {
        super(props);
        bindAllOfThis(this, OrganizeDeskGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserOrganizeDeskGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default OrganizeDeskGame;



// WEBPACK FOOTER //
// ./src/pages/game/OrganizeDeskGame.tsx